// 手机号码
export const patternPhone = {
  reg: /^((1[3-9]\d{9})|(\d{3,4}-\d{7,8})|(\d{7,8}))$/,
  msg: "请输入有效的手机号",
};

// 中国大陆身份证号
export const patternIdCard = {
  reg: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  msg: "请输入有效的身份证号",
};

// 统一社会信用代码
export const patternSocialCreditCode = {
  reg: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
  msg: "请输入有效的统一社会信用代码",
};

// 数字
export const patternNumber = {
  reg: /^\d+(\.\d+)?$/, // ^ [0-9]*$
  msg: "请输入有效的数字",
};

// 大写数字
export const patternNumberUpper = {
  reg: /^壹|贰|叁|肆|伍|陆|柒|捌|玖|拾|零|佰|仟|万|亿|廿|卅|卌$/,
  msg: "请输入有效的大写数字",
};

// 网址
export const patternUrl = {
  reg: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
  msg: "请输入有效的网址",
};

// 英文与数字
export const patternAlphanumeric = {
  reg: /^[a-zA-Z0-9]+$/,
  msg: "请输入有效的英文或数字",
};

export default {
  patternPhone,
  patternIdCard,
  patternSocialCreditCode,
  patternNumber,
  patternNumberUpper,
  patternUrl,
  patternAlphanumeric
};
